<template>
  <el-dialog
    :visible.sync="visible"
    width="420px"
    :show-close="false"
    :close-on-click-modal="false"
    append-to-body
    custom-class="course-open-tip-dialog"
  >
    <div class="course-open-tip">
      <div class="course-open-tip__banner">
        <div class="course-open-tip__icon">
          <i class="el-icon-warning-outline"></i>
        </div>
      </div>
      <div class="course-open-tip__body">
        <p class="course-open-tip__title">提示</p>
        <div class="course-open-tip__message">{{ message }}</div>
        <button type="button" class="course-open-tip__btn" @click="handleClose">我知道了</button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { COURSE_NOT_OPEN_MSG } from '@/utils/courseOpen'

export default {
  name: 'CourseOpenTip',
  props: {
    message: {
      type: String,
      default: COURSE_NOT_OPEN_MSG,
    },
  },
  data() {
    return {
      visible: false,
    }
  },
  methods: {
    open() {
      this.visible = true
    },
    handleClose() {
      this.visible = false
      this.$emit('close')
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/variable.scss";

.course-open-tip {
  overflow: hidden;
}

.course-open-tip__banner {
  padding: 28px 0 20px;
  background: linear-gradient(180deg, $primary-light-2 0%, #fff 100%);
  text-align: center;
}

.course-open-tip__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: linear-gradient(180deg, #fff 0%, $primary-light 100%);
  border: 1px solid $primary-border;
  box-shadow: 0 4px 12px $primary-shadow;

  i {
    font-size: 28px;
    color: $primary;
  }
}

.course-open-tip__body {
  padding: 4px 32px 32px;
  text-align: center;
}

.course-open-tip__title {
  margin: 0 0 16px;
  font-size: 18px;
  font-weight: bold;
  color: #333;
  letter-spacing: 1px;
}

.course-open-tip__message {
  margin-bottom: 28px;
  padding: 14px 16px;
  font-size: 14px;
  line-height: 1.8;
  color: #666;
  text-align: left;
  background: $primary-light-3;
  border: 1px solid $primary-border;
  border-radius: 8px;
}

.course-open-tip__btn {
  min-width: 140px;
  height: 40px;
  padding: 0 32px;
  font-size: 14px;
  color: #fff;
  border: none;
  border-radius: 20px;
  cursor: pointer;
  background: linear-gradient(90deg, #1687de 0%, #4084ff 100%);
  box-shadow: 0 4px 10px rgba(63, 107, 187, 0.35);
  transition: opacity 0.2s, transform 0.2s;

  &:hover {
    opacity: 0.92;
    transform: translateY(-1px);
  }

  &:active {
    transform: translateY(0);
  }
}
</style>

<style lang="scss">
.course-open-tip-dialog {
  border-radius: 12px;
  overflow: hidden;

  .el-dialog__header {
    display: none;
  }

  .el-dialog__body {
    padding: 0;
  }
}
</style>
